export default {
  HYBRID_PRICE: 1836,
  HYBRID_INSTALLATION_PRICE: 3000,
  MAX_HYBRID_PRICE: 2500,
  MAX_HYBRID_INSTALLATION_PRICE: 4000,
  ELECTRIC_PRICE: 509,
  ELECTRIC_INSTALLATION_PRICE: 3000,
  ELECTRIC_ANNUAL_KILOWATTS: 3493,
  HYBRID_ANNUAL_KILOWATTS: 836,
  HYBRID_MODEL_FOR_API_REQUEST: 'XE50T06ST45U1',
  ZIP_CODE_LENGTH: 5,
  API_FOR_REBATE_PROGRAMS: 'https://rheem.ecorebates.com/api/search/rheem/productRebateDetails.json?sku=XE50T06ST45U1',
  API_FOR_STATE_BY_ZIP: 'https://api.zippopotam.us/us',
  MAIN_COLOR: '#e70033',
  IMG_DIR: '/wp-content/themes/RheemTheme/hybrid-saving-calculator/dist-us/img',
  AVERAGE_RATE: 0.14,
  RATES: [
    { state: 'Hawaii', rate: 0.3962 },
    { state: 'New Hampshire', rate: 0.2439 },
    { state: 'Massachusetts', rate: 0.3028 },
    { state: 'California', rate: 0.3268 },
    { state: 'Connecticut', rate: 0.2915 },
    { state: 'Rhode Island', rate: 0.2871 },
    { state: 'Alaska', rate: 0.247 },
    { state: 'New York', rate: 0.2469 },
    { state: 'Maine', rate: 0.263 },
    { state: 'Vermont', rate: 0.2535 },
    { state: 'Michigan', rate: 0.1871 },
    { state: 'Pennsylvania', rate: 0.1807 },
    { state: 'Illinois', rate: 0.1721 },
    { state: 'Indiana', rate: 0.1633 },
    { state: 'New Jersey', rate: 0.1964 },
    { state: 'Wisconsin', rate: 0.169 },
    { state: 'Delaware', rate: 0.181 },
    { state: 'Maryland', rate: 0.1842 },
    { state: 'District of Columbia', rate: 0.1893 },
    { state: 'Ohio', rate: 0.1656 },
    { state: 'Nevada', rate: 0.1527 },
    { state: 'Alabama', rate: 0.1548 },
    { state: 'Kansas', rate: 0.1483 },
    { state: 'Colorado', rate: 0.1526 },
    { state: 'Minnesota', rate: 0.1486 },
    { state: 'Texas', rate: 0.156 },
    { state: 'New Mexico', rate: 0.1447 },
    { state: 'South Carolina', rate: 0.1594 },
    { state: 'Virginia', rate: 0.1494 },
    { state: 'Oklahoma', rate: 0.1311 },
    { state: 'West Virginia', rate: 0.1587 },
    { state: 'Georgia', rate: 0.1431 },
    { state: 'Florida', rate: 0.1427 },
    { state: 'Louisiana', rate: 0.1187 },
    { state: 'Kentucky', rate: 0.1377 },
    { state: 'North Carolina', rate: 0.1511 },
    { state: 'Mississippi', rate: 0.1426 },
    { state: 'Iowa', rate: 0.1328 },
    { state: 'South Dakota', rate: 0.1346 },
    { state: 'Arizona', rate: 0.1517 },
    { state: 'Tennessee', rate: 0.1377 },
    { state: 'Arkansas', rate: 0.246 },
    { state: 'Montana', rate: 0.1254 },
    { state: 'Missouri', rate: 0.127 },
    { state: 'Nebraska', rate: 0.1225 },
    { state: 'Wyoming', rate: 0.1278 },
    { state: 'Oregon', rate: 0.1484 },
    { state: 'North Dakota', rate: 0.1131 },
    { state: 'Idaho', rate: 0.1134 },
    { state: 'Utah', rate: 0.1091 },
    { state: 'Washington', rate: 0.1239 },
  ],
  GET_REBATE_PROGRAMS: (rebateResponse) => {
    const productRebateDetails = rebateResponse.productRebateDetails
      .filter((rebate) => rebate.filters.product_type.indexOf('heatpump') > -1);
    return productRebateDetails.length > 0
      ? productRebateDetails[0].rebatePrograms
        .filter((item) => item.id !== '22446') // custom filter logic from the old version
        .map((item) => {
          let value = 0;
          let percent = 0;
          let enabled = false;
          if (item.purchaseRebate.units === 'USD') {
            value = item.purchaseRebate.amount;
          } else if (item.purchaseRebate.units === 'PCT_OFF_SALE_PRICE') {
            const regexpRes = item.amountLabel.match(/up\sto\s\$(.*)\)/);
            if (regexpRes && regexpRes[1]) {
              value = +regexpRes[1].replace(',', '');
            }
          }
          const regexpResPercent = item.amountLabel.match(/(.*)%\sof\sproject\scost/);
          if (regexpResPercent && regexpResPercent[1]) {
            percent = +regexpResPercent[1];
          }
          if (!Number.isNaN(value) && value > 0) {
            enabled = true;
          }
          return {
            ...item,
            value,
            percent,
            enabled,
            checked: item.id === '21753', // custom pre-checked logic from the old version
          };
        }) : [];
  },
  STEPS: [
    { id: 1, label: '1. Price & Rate' },
    { id: 2, label: '2. Rebates & Incentives' },
    { id: 3, label: '3. Return on investment' },
  ],
  ROI_BACKGROUND_IMAGE: 'ROI-background.jpg',
  SHOW_KWIKCOMFORT_BLOCK: true,
  FULL_LEGAL_DISCLAIMER: true,
};
